import { client } from '../default.client';
import getAddressSuggestionsAdapter from '../adapters/geocoder/get-address-suggestions.adapter';
import getReverseGeoAdapter from '../adapters/geocoder/get-reverse-geo.adapter';
import type {
	IAddressSuggestion,
	IReverseGeocoding
} from '@/types/interfaces/chocofood';
import type { ICoordinates } from '@/types/interfaces/common';

export const geocoder = {
	async getSuggestions(address: string): Promise<IAddressSuggestion[]> {
		const params = {
			address,
			limit: 3
		};

		const response = await client.get('geocoder/api/v1/suggestions', {
			params
		});

		return getAddressSuggestionsAdapter(response.data.data);
	},
	async getReverseGeocode(
		coordinates: ICoordinates
	): Promise<IReverseGeocoding[]> {
		const params = {
			lat: coordinates.latitude,
			long: coordinates.longitude
		};

		const response = await client.get('geocoder/api/v1/reverse-geocode', {
			params
		});

		return getReverseGeoAdapter(response.data.data);
	}
};
